import { IConfig } from '@cian/config/shared';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { IPreloadedState } from 'shared/types/redux';
import { useApplicationContext } from 'shared/utils/applicationContext';

type TSelector<T> = (state: IPreloadedState) => T;

type TSelectorWithConfig<T> = (config: IConfig) => TSelector<T>;

export const useSelectorWithConfig = <T>(selector: TSelectorWithConfig<T>) => {
  const { config } = useApplicationContext();

  const memoizedSelector = useMemo(() => selector(config), [config, selector]);

  return useSelector<IPreloadedState, T>(memoizedSelector);
};
